import { LumieBg } from './lumie-bg'
import { registerHealth } from './health/register'
import type { TenantPluginRegister } from '@yeshuman/sdk'

export const register: TenantPluginRegister = (app) => {
  registerHealth(app)
  app.chrome.background(LumieBg)
  app.register({
    guestMarketingShellBackground: false,
    guestBackgroundClassName: 'opacity-75 dark:opacity-70',
  })
}

export const providesDomains = ['health']

export const requiresProduct = '>=2.11,<3'
